import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip
} from '@mui/material';
import axios from 'axios';
import "./AddIntegredetInput.css"
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const options = [
    { key: 'name', value: 'სახელი' },
    { key: 'address', value: 'მისამართი' },
    { key: 'status', value: 'სტატუსი' },
    { key: 'name', value: 'ობიექტის ექსპლუატაციის გამწევი პირის დასახელება' },
    { key: 'name', value: 'ნებართვის მაძიებელი/მფლობელი ორგანიზაცია' },
    { key: 'address', value: 'ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი' },
    { key: 'name', value: 'ობიექტის მფლობელის დასახელება' },
    { key: 'address', value: 'ობიექტის მფლობელის იურიდიული მისამართი' },
    { key: 'address', value: 'ორგანიზაციის იურიდიული მისამართი'},
];

function AddIntegratedInput({sortIncrement = 100, onAdded}) {
    const [open, setOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [caseId, setCaseId] = useState('');

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        setCaseId(params.get('id'));
    }, []);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedOptions(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleSubmit = async () => {
        for (let selectedOption of selectedOptions) {
            const option = options.find(option => option.value === selectedOption);
            if (!option) continue;

            const payload = {
                title: option.value,
                value: "",
                type: 3,
                required: false,
                caseId: parseInt(caseId),
                sort: sortIncrement + 1,
                integration: 2,
                integrationPropertyName: option.key,
            };

            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewInputType`, payload);
            } catch (error) {
            }
        }
        setOpen(false);
        onAdded();
    };
    const handleDelete = (optionToDelete) => {
        setSelectedOptions(selectedOptions.filter(option => option !== optionToDelete));
    };

    return (
        <div>
            <Button variant="outlined" onClick={() => setOpen(true)}>რეესტრის ველების დამატება</Button>
            <Dialog style={{minHeight: 500}} fullWidth open={open} onClose={() => setOpen(false)}>
                <h1 className={"integration-popup-title"}>საჯარო რეესტრის ველები</h1>
                <DialogContent>
                    <FormControl fullWidth>
                        <InputLabel id="demo-multiple-checkbox-label">აირჩიეთ ველები</InputLabel>
                        <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={selectedOptions}
                            onChange={handleChange}
                            input={<OutlinedInput label="აირჩიეთ ველები"/>}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            {options.map((option) => (
                                <MenuItem key={option.key} value={option.value}>
                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1}/>
                                    <ListItemText primary={option.value}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {selectedOptions.length > 0 && (
                    <div className="selected-options-preview">
                        {selectedOptions.map((selectedOption, index) => (
                            <Chip
                                key={index}
                                label={selectedOption}
                                // Optional: Add a delete icon to remove an option. Handle the delete event accordingly.
                                onDelete={() => handleDelete(selectedOption)}
                                color="primary"
                                variant="outlined"
                            />
                        ))}
                    </div>
                        )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubmit}>დამატება</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AddIntegratedInput;
